import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'urlToExtension',
  standalone: true,
})
export class UrlToExtensionPipe implements PipeTransform {
  transform(value: string): string {
    return (
      value?.split('?').at(0)?.split('.').at(-1)?.toLowerCase() ?? ''
    );
  }
}
